/// <reference path="../../Common/Helpers/GridEditorBase.ts" />

namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class ReceiptDetailsEditor extends _Ext.ItemGridEditor<ReceiptDetailsRow> {
        protected getColumnsKey() { return "Retail.ReceiptDetails"; }
        protected getDialogType() { return ReceiptDetailsDialog; }
        protected getLocalTextPrefix() { return ReceiptDetailsRow.localTextPrefix; }
        exchangerate: number;
        rateid: string;
        constructor(container: JQuery) {
            super(container);

            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as any).CalculateTotals();
                }
            })

        }

        
        validateEntity(row, id) {
            var sameProduct = Q.tryFirst(this.view.getItems(), x => x.LedgerId === row.LedgerId);
            if (sameProduct && this.id(sameProduct) !== id) {
                Q.alert('This Ledger is already in order details!');
                return false;
            }

            row.LedgerName = OMS.AccountLedgerRow.getLookup().itemById[row.LedgerId].LedgerName;
            //row.LineTotal = (row.Quantity || 0) * (row.UnitPrice || 0) - (row.Discount || 0);
            return true;
        }

        

    }
}